import { PropertyGroup } from "../property-group";
import { entropyProperty } from "./entropy-property";
import { transcendenceProperty } from "./transcendence-property";

export const utilizationGroup = new PropertyGroup("Utilization", [entropyProperty, transcendenceProperty])
